(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["free-shipping-combinations-block"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('free-shipping-combinations')) {
    class FreeShippingCombinations extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.summaryElement = this.querySelector('[data-summary]');
        this.feedbackElement = this.querySelector('[data-feedback]');
        this.loadingElement = this.querySelector('[data-loading]');
        this.emptyElement = this.querySelector('[data-empty]');
        this.cardsElement = this.querySelector('[data-cards]');
        this.refreshToken = 0;
        this.refreshTimers = [];

        try {
          this.config = JSON.parse(this.querySelector('[data-fsc-config]').textContent);
          this.products = JSON.parse(this.querySelector('[data-fsc-products]').textContent);
        } catch (error) {
          this.showFatalError();
          return;
        }

        this.boundCartEvent = (event) => {
          if (event.detail && event.detail.source === this) return;
          this.scheduleRefresh(180);
        };

        this.boundSubmit = (event) => {
          const form = event.target instanceof Element
            ? event.target.closest('form[action*="/cart/add"]')
            : null;
          if (!form || this.contains(form)) return;
          this.scheduleRefresh(750);
          this.scheduleRefresh(1800);
        };

        document.addEventListener('cart:updated', this.boundCartEvent);
        document.addEventListener('cart:change', this.boundCartEvent);
        document.addEventListener('product:added', this.boundCartEvent);
        document.addEventListener('submit', this.boundSubmit, true);

        this.hidden = false;
        this.refresh();
      }

      disconnectedCallback() {
        document.removeEventListener('cart:updated', this.boundCartEvent);
        document.removeEventListener('cart:change', this.boundCartEvent);
        document.removeEventListener('product:added', this.boundCartEvent);
        document.removeEventListener('submit', this.boundSubmit, true);
        this.refreshTimers.forEach((timer) => window.clearTimeout(timer));
      }

      get routeRoot() {
        const configuredRoot = window.Shopify && window.Shopify.routes
          ? window.Shopify.routes.root
          : '/';
        return configuredRoot.endsWith('/') ? configuredRoot : `${configuredRoot}/`;
      }

      scheduleRefresh(delay) {
        const timer = window.setTimeout(() => this.refresh(), delay);
        this.refreshTimers.push(timer);
      }

      async fetchCart() {
        const response = await fetch(`${this.routeRoot}cart.js`, {
          method: 'GET',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        });
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      }

      async refresh(options = {}) {
        const token = ++this.refreshToken;
        this.setBusy(true);

        try {
          const cart = await this.fetchCart();
          if (token !== this.refreshToken) return;
          this.cart = cart;
          this.render(cart, options);
        } catch (error) {
          if (token !== this.refreshToken) return;
          this.showFatalError();
        } finally {
          if (token === this.refreshToken) this.setBusy(false);
        }
      }

      render(cart, options = {}) {
        const threshold = Number(this.config.threshold);
        const cartTotal = Number(cart.total_price || 0);

        this.loadingElement.hidden = true;
        this.cardsElement.hidden = true;
        this.emptyElement.hidden = true;
        this.summaryElement.hidden = true;
        this.cardsElement.replaceChildren();
        this.classList.remove('fsc--ready', 'fsc--single', 'fsc--multiple');

        if (!Number.isFinite(threshold) || threshold <= 0) {
          this.showEmpty(this.config.text.empty);
          return;
        }

        if (cartTotal >= threshold) {
          if (options.afterAdd) {
            this.hidden = false;
            this.showFeedback(`${this.config.text.success} ${this.config.text.reached}`, 'success');
            window.setTimeout(() => {
              if (Number(this.cart && this.cart.total_price) >= threshold) this.hidden = true;
            }, 3000);
          } else {
            this.hidden = true;
          }
          return;
        }

        const currency = cart.currency || this.config.shopCurrency;
        const remaining = threshold - cartTotal;
        const maximumFinalTotal = Math.round(
          threshold * (1 + Number(this.config.maxOvershootPercent) / 100)
        );
        const maximumCombinationTotal = maximumFinalTotal - cartTotal;
        const eligibleProducts = this.getEligibleProducts(cart);
        const combinations = this.findCombinations(
          eligibleProducts,
          remaining,
          maximumCombinationTotal
        );

        this.hidden = false;
        this.summaryElement.innerHTML = this.escapeHtml(
          this.replaceAmount(this.config.text.remaining, this.formatMoney(remaining, currency))
        ).replace(
          this.escapeHtml(this.formatMoney(remaining, currency)),
          `<strong>${this.escapeHtml(this.formatMoney(remaining, currency))}</strong>`
        );
        this.summaryElement.hidden = false;

        if (!combinations.length) {
          this.showEmpty(this.config.text.empty);
          return;
        }

        this.classList.add(combinations.length === 1 ? 'fsc--single' : 'fsc--multiple');
        this.cardsElement.dataset.combinationCount = String(combinations.length);

        combinations.forEach((combination, index) => {
          this.cardsElement.append(
            this.createCard(combination, index, cartTotal, threshold, maximumFinalTotal, currency)
          );
        });

        this.cardsElement.hidden = false;
        window.requestAnimationFrame(() => this.classList.add('fsc--ready'));
      }

      getEligibleProducts(cart) {
        const cartProductIds = new Set(
          (cart.items || []).map((item) => String(item.product_id))
        );
        const currentProductId = this.config.currentProductId == null
          ? null
          : String(this.config.currentProductId);

        return (this.products || [])
          .map((product) => {
            const variants = (product.variants || [])
              .filter((variant) => variant.available && Number(variant.price) >= 0)
              .map((variant) => ({
                ...variant,
                id: String(variant.id),
                price: Number(variant.price)
              }));
            return { ...product, id: String(product.id), variants };
          })
          .filter((product) => product.variants.length > 0)
          .filter((product) => {
            if (this.config.excludeCartProducts && cartProductIds.has(product.id)) return false;
            if (
              this.config.excludeCurrentProduct &&
              currentProductId &&
              product.id === currentProductId
            ) return false;
            return true;
          });
      }

      findCombinations(products, minimumTotal, maximumTotal) {
        const matches = [];
        const maxItems = Math.max(1, Math.min(3, Number(this.config.maxProductsPerCombo) || 3));
        const wanted = Math.max(1, Math.min(3, Number(this.config.combinationCount) || 3));

        const visit = (startIndex, selected, total) => {
          for (let index = startIndex; index < products.length; index += 1) {
            const product = products[index];
            const selectedVariant = product.variants[0];
            const nextTotal = total + selectedVariant.price;
            if (nextTotal > maximumTotal) continue;

            const nextSelected = [
              ...selected,
              { product, selectedVariant }
            ];

            if (nextTotal >= minimumTotal) {
              matches.push({
                items: nextSelected,
                total: nextTotal,
                surplus: nextTotal - minimumTotal
              });
            }

            if (nextSelected.length < maxItems) {
              visit(index + 1, nextSelected, nextTotal);
            }
          }
        };

        visit(0, [], 0);

        matches.sort((first, second) => {
          if (first.surplus !== second.surplus) return first.surplus - second.surplus;
          if (first.items.length !== second.items.length) {
            return second.items.length - first.items.length;
          }
          return first.total - second.total;
        });

        return matches.slice(0, wanted);
      }

      createCard(combination, index, cartTotal, threshold, maximumFinalTotal, currency) {
        const card = document.createElement('article');
        card.className = 'fsc__card';

        const state = {
          items: combination.items.map((item) => ({
            product: item.product,
            selectedVariant: item.selectedVariant
          })),
          cartTotal,
          threshold,
          maximumFinalTotal,
          currency
        };

        const productsMarkup = state.items.map((item, itemIndex) => {
          const product = item.product;
          const variant = item.selectedVariant;
          const image = variant.image || product.image;
          const hasRealVariants = product.variants.length > 1;
          const options = product.variants.map((optionVariant) => {
            const priceSuffix = optionVariant.price !== variant.price
              ? ` · ${this.formatMoney(optionVariant.price, currency)}`
              : '';
            return `<option value="${this.escapeAttribute(optionVariant.id)}">${this.escapeHtml(optionVariant.title + priceSuffix)}</option>`;
          }).join('');
          const imageMarkup = image
            ? `<img class="fsc__image" src="${this.escapeAttribute(image)}" alt="${this.escapeAttribute(product.title)}" width="480" height="480" loading="lazy" data-product-image>`
            : `<span class="fsc__image-placeholder">${this.escapeHtml(this.config.text.imageMissing)}</span>`;
          const productMarkup = `
            <div class="fsc__product">
              <a class="fsc__image-wrap" href="${this.escapeAttribute(product.url)}" tabindex="-1" aria-hidden="true">
                ${imageMarkup}
              </a>
              <a class="fsc__product-title" href="${this.escapeAttribute(product.url)}">${this.escapeHtml(product.title)}</a>
              ${hasRealVariants ? `
                <label>
                  <span class="visually-hidden">${this.escapeHtml(product.title)}</span>
                  <select class="fsc__variant" data-item-index="${itemIndex}" aria-label="${this.escapeAttribute(product.title)}">
                    ${options}
                  </select>
                </label>
              ` : ''}
            </div>
          `;

          if (itemIndex === 0) return productMarkup;
          return `<span class="fsc__plus" aria-hidden="true">+</span>${productMarkup}`;
        }).join('');

        card.innerHTML = `
          <p class="fsc__card-label">${this.escapeHtml(this.config.text.combination)} ${index + 1}</p>
          <div class="fsc__products">${productsMarkup}</div>
          <div class="fsc__details">
            <div class="fsc__price-row">
              <span>${this.escapeHtml(this.config.text.price)}</span>
              <span class="fsc__total" data-combination-total></span>
            </div>
            <p class="fsc__result" data-combination-result></p>
            <button class="fsc__button" type="button" data-add-combination>
              ${this.escapeHtml(this.config.text.button)}
            </button>
          </div>
        `;

        card.querySelectorAll('[data-item-index]').forEach((select) => {
          select.addEventListener('change', () => {
            const itemIndex = Number(select.dataset.itemIndex);
            const item = state.items[itemIndex];
            const selectedVariant = item.product.variants.find(
              (variant) => variant.id === select.value
            );
            if (!selectedVariant) return;
            item.selectedVariant = selectedVariant;
            const image = card.querySelectorAll('.fsc__product')[itemIndex]
              .querySelector('[data-product-image]');
            if (image && (selectedVariant.image || item.product.image)) {
              image.src = selectedVariant.image || item.product.image;
            }
            this.updateCard(card, state);
          });
        });

        card.querySelector('[data-add-combination]').addEventListener('click', (event) => {
          this.addCombination(state, event.currentTarget);
        });

        this.updateCard(card, state);
        return card;
      }

      updateCard(card, state) {
        const combinationTotal = state.items.reduce(
          (total, item) => total + item.selectedVariant.price,
          0
        );
        const projectedTotal = state.cartTotal + combinationTotal;
        const resultElement = card.querySelector('[data-combination-result]');
        const button = card.querySelector('[data-add-combination]');

        card.querySelector('[data-combination-total]').textContent = this.formatMoney(
          combinationTotal,
          state.currency
        );

        if (projectedTotal < state.threshold) {
          const missing = state.threshold - projectedTotal;
          resultElement.textContent = this.replaceAmount(
            this.config.text.below,
            this.formatMoney(missing, state.currency)
          );
          button.disabled = true;
          return;
        }

        if (projectedTotal > state.maximumFinalTotal) {
          resultElement.textContent = this.config.text.above;
          button.disabled = true;
          return;
        }

        const overage = projectedTotal - state.threshold;
        resultElement.textContent = overage === 0
          ? this.config.text.exact
          : this.replaceAmount(
              this.config.text.over,
              this.formatMoney(overage, state.currency)
            );
        button.disabled = false;
      }

      async addCombination(state, button) {
        if (button.disabled) return;

        const originalText = button.textContent;
        button.disabled = true;
        button.textContent = `${this.config.text.button} …`;
        this.hideFeedback();

        const body = {
          items: state.items.map((item) => ({
            id: item.selectedVariant.id,
            quantity: 1
          }))
        };
        const sectionIds = String(this.config.cartSections || '')
          .split(',')
          .map((sectionId) => sectionId.trim())
          .filter(Boolean);

        if (sectionIds.length) {
          body.sections = sectionIds;
          body.sections_url = `${window.location.pathname}${window.location.search}`;
        }

        try {
          const response = await fetch(`${this.routeRoot}cart/add.js`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify(body)
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'Add to cart failed');

          if (result.sections) this.replaceCartSections(result.sections);

          if (this.config.afterAdd === 'cart') {
            window.location.assign(`${this.routeRoot}cart`);
            return;
          }

          await this.refreshThemeCart(result);
          const cart = await this.fetchCart();
          this.cart = cart;
          this.dispatchCartEvents(cart, state);
          this.render(cart, { afterAdd: true });
        } catch (error) {
          this.showFeedback(this.config.text.error, 'error');
          button.disabled = false;
          button.textContent = originalText;
        }
      }

      async refreshThemeCart(result) {
        const shouldOpen = this.config.openCartDrawer !== false;
        const thriveCartForm = document.getElementById('AjaxCartForm');

        if (thriveCartForm) {
          try {
            const helperUrl = new URL(window.location.href);
            helperUrl.search = '';
            helperUrl.searchParams.set('section_id', 'helper-cart');
            const response = await fetch(helperUrl.toString(), {
              method: 'GET',
              headers: { Accept: 'text/html' },
              credentials: 'same-origin'
            });
            if (!response.ok) throw new Error('Thrive cart section request failed');

            const html = await response.text();
            if (typeof window.renderHelperCart === 'function') {
              window.renderHelperCart(html);
            } else {
              this.replaceThriveCart(html);
            }

            const recommendations = document.querySelector('cart-recommendations');
            if (
              recommendations &&
              typeof recommendations.generateRecommendations === 'function'
            ) {
              recommendations.innerHTML = '';
              recommendations.generateRecommendations();
            }

            if (shouldOpen) this.openThemeCartDrawer();
            return;
          } catch (error) {
            if (typeof window.refreshCart === 'function') {
              window.refreshCart(shouldOpen);
              return;
            }
          }
        }

        if (result.sections) this.replaceCartSections(result.sections);
        if (shouldOpen) this.openThemeCartDrawer();
      }

      replaceThriveCart(html) {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const incomingForm = parsed.getElementById('AjaxCartForm');
        const incomingSubtotal = parsed.getElementById('AjaxCartSubtotal');
        const currentForm = document.getElementById('AjaxCartForm');
        const currentSubtotal = document.getElementById('AjaxCartSubtotal');

        if (!incomingForm || !currentForm) throw new Error('Thrive cart markup missing');
        currentForm.innerHTML = incomingForm.innerHTML;
        if (typeof currentForm.ajaxifyCartItems === 'function') {
          currentForm.ajaxifyCartItems();
        }

        if (incomingSubtotal && currentSubtotal) {
          currentSubtotal.innerHTML = incomingSubtotal.innerHTML;
        }

        const count = currentForm.querySelector('[data-cart-count]');
        const total = currentForm.querySelector('[data-cart-total]');
        document.querySelectorAll('[data-header-cart-count]').forEach((element) => {
          if (count) element.textContent = count.textContent;
        });
        document.querySelectorAll('[data-header-cart-total]').forEach((element) => {
          if (total) element.textContent = total.textContent;
        });
      }

      openThemeCartDrawer() {
        const thriveDrawer = document.querySelector('[data-js-site-cart-sidebar]');
        if (thriveDrawer && typeof thriveDrawer.show === 'function') {
          thriveDrawer.show();
          return;
        }

        const drawer = document.querySelector('cart-drawer, mini-cart');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
          return;
        }
        if (drawer && typeof drawer.show === 'function') {
          drawer.show();
          return;
        }

        const drawerHandle = document.querySelector(
          '[data-js-sidebar-handle][aria-controls="site-cart-sidebar"]'
        );
        if (drawerHandle) drawerHandle.click();
      }

      replaceCartSections(sections) {
        Object.entries(sections).forEach(([sectionId, html]) => {
          if (!html) return;
          const currentSection = document.getElementById(`shopify-section-${sectionId}`);
          if (!currentSection) return;

          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const newSection = parsed.getElementById(`shopify-section-${sectionId}`);
          currentSection.innerHTML = newSection ? newSection.innerHTML : html;
        });
      }

      dispatchCartEvents(cart, state) {
        const detail = { cart, source: this };
        document.dispatchEvent(new CustomEvent('cart:updated', { detail }));
        document.dispatchEvent(new CustomEvent('cart:change', { detail }));
        window.dispatchEvent(new CustomEvent('cart:refresh', { detail }));

        if (window.KROWN && window.KROWN.functions && state) {
          const lines = state.items.map((item) => ({
            merchandiseId: item.selectedVariant.id,
            quantity: 1
          }));

          if (typeof window.KROWN.functions.eventDispatcher === 'function') {
            window.KROWN.functions.eventDispatcher('krown:cart:add', {
              source: 'free-shipping-combinations',
              variantIds: lines.map((line) => line.merchandiseId)
            });
          }

          if (typeof window.KROWN.functions.dispatchStandardEvent === 'function') {
            window.KROWN.functions.dispatchStandardEvent('CartLinesUpdateEvent', this, {
              action: 'add',
              context: 'product',
              lines,
              promise: Promise.resolve({ cart })
            });
          }
        }
      }

      setBusy(isBusy) {
        this.setAttribute('aria-busy', String(isBusy));
      }

      showEmpty(message) {
        this.hidden = false;
        this.emptyElement.textContent = message;
        this.emptyElement.hidden = false;
        this.cardsElement.hidden = true;
      }

      showFeedback(message, state) {
        this.feedbackElement.textContent = message;
        this.feedbackElement.dataset.state = state;
        this.feedbackElement.hidden = false;
      }

      hideFeedback() {
        this.feedbackElement.hidden = true;
        this.feedbackElement.removeAttribute('data-state');
      }

      showFatalError() {
        this.hidden = false;
        this.loadingElement.hidden = true;
        this.cardsElement.hidden = true;
        this.summaryElement.hidden = true;
        this.emptyElement.textContent = this.config && this.config.text
          ? this.config.text.error
          : 'Der Block konnte nicht geladen werden.';
        this.emptyElement.hidden = false;
        this.setBusy(false);
      }

      replaceAmount(template, amount) {
        return String(template || '').split('[amount]').join(amount);
      }

      formatMoney(amount, currency) {
        const locale = document.documentElement.lang || 'cs-CZ';
        try {
          return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currency || this.config.shopCurrency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
          }).format(Number(amount) / 100);
        } catch (error) {
          return `${(Number(amount) / 100).toFixed(2)} ${currency || ''}`.trim();
        }
      }

      escapeHtml(value) {
        return String(value == null ? '' : value).replace(/[&<>'"]/g, (character) => ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          "'": '&#039;',
          '"': '&quot;'
        })[character]);
      }

      escapeAttribute(value) {
        return this.escapeHtml(value);
      }
    }

    customElements.define('free-shipping-combinations', FreeShippingCombinations);
  }
  } catch(e) { console.error(e); }
})();

})();
